import React, { useState, useEffect } from 'react';
import { fetchBusinessInfo, fetchProductOffer } from '../bridge';
import OfferPresentation from './OfferPresentation';
import '../styles/Category.css'

const OffersSection = ({ supabase, userEmail, uploaderId }) => {
  const [images, setImages] = useState([]);
  const [productInfo, setProductInfo] = useState([]);
  const [businessCurrency, setBusinessCurrency] = useState('$');

  useEffect(() => {
    fetchData();
  }, [userEmail, uploaderId]);

  const fetchData = async () => {
    const previousBusinessInfo = await fetchBusinessInfo(userEmail);
    if (previousBusinessInfo) {
      setBusinessCurrency(previousBusinessInfo.business_currency || '$');
    }

    await fetchImages();
  };

  const fetchImages = async () => {
    if (!userEmail) {
      return;
    }

    const { data, error } = await supabase.storage.from('images').list(`${userEmail}/${uploaderId}`);

    if (error) {
      return;
    }

    if (Array.isArray(data) && data.length > 0) {
      const imageData = data.map(file => ({
        id: file.name,
        url: supabase.storage.from('images').getPublicUrl(`${userEmail}/${uploaderId}/${file.name}`).data.publicUrl,
        name: file.name,
      }));

      setImages(imageData);
      await retrieveProductInfo(imageData);
    } else {
      setImages([]);
      setProductInfo([]);
    }
  };

  const retrieveProductInfo = async (imageData) => {
    try {
      const productInfoArray = await Promise.all(imageData.map(async (image) => {
        const productInfo = await fetchProductOffer({ userEmail, categoryId: uploaderId, imageIndex: image.id });
        return productInfo || { product_name: '', product_price: '', previous_product_price: '', product_description: '' };
      }));

      setProductInfo(productInfoArray);
    } catch (error) {
      return;
    }
  };

  if (images.length === 0) {
    return null;
  }

  return (
    <div className='category-container'>
      <h2 className='category-name'>Offers</h2>
      <div className='image-row'>
        {images.map((image, index) => (
          <OfferPresentation key={index} image={image} index={index} productInfo={productInfo} currency={businessCurrency} />
        ))}
      </div>
    </div>
  );
};

export default OffersSection;